module.exports = __webpack_public_path__ + "static/media/shriGanesha.b743fe10.jpg";